import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ICurrentWorkspaceBl } from '../../CurrentWorkspace.bl';
import { CurrentWorkspaceSelectLinkInTable } from './CurrentWorkspaceSelectLinkInTable';

interface IProps {
  name: string;
  workspaceId: string;
  isEncrypted: boolean;
  isLocked: boolean;
  isMy: boolean;
}

export const CurrentWorkspaceSelectLinkTableContainer = observer((props: IProps): ReactElement => {
  const { workspaceId, name, isEncrypted, isLocked, isMy } = props;
  const bl = useInjection(ICurrentWorkspaceBl.$);

  const handleClick = (): void => {
    bl.selectWorkspace(workspaceId);
  };

  return (
    <CurrentWorkspaceSelectLinkInTable
      workspaceId={workspaceId}
      onClick={handleClick}
      name={name}
      isEncrypted={isEncrypted}
      isLocked={isLocked}
      isMy={isMy}
    />
  );
});
